import React from "react";
import PropTypes from "prop-types";
import Modal from "components/Modal";
import { Link } from "react-router-dom";
import {isFunction} from "lodash-es";

const InternalServerError = ({returnUrl, returlLinkTitle, onClickButton, errorMessage}) => {
    return (
        <Modal
            visible={true}
            onClose={close}
            closeOnOverlay={false}
            bodyModificators={[`app-hide`]}
            modificators={[
                `tablet-page`,
                `sign`,
                `keyboard`,
                `registration`,
            ]}
        >
            <div className="reg reg--not-found max-w-568">
                <div className="reg__top">
                    <h1 className="fs-h1 reg__title">{errorMessage}</h1>
                </div>

                <div className="reg__body">
                    <div className="reg__main">
                        <div className="c-gs-medium-em mb-40">
                            <p className="mb-8">Ошибка на странице</p>
                            <p className="mb-8">Попробуйте обновить страницу позже.</p>
                            <p>Если ошибка повторяется — напишите нам об этом на электронную почту —
                                <a className="c-secondary-dark" href="mailto:idem@naigru.com">idem@naigru.com.</a>
                            </p>
                        </div>

                        <div className="btn-group btn-group--bottom">
                            {isFunction(onClickButton)
                                ? (
                                    <button
                                        className="btn btn--medium btn--primary"
                                        onClick={onClickButton}
                                    >
                                        <span>{returlLinkTitle}</span>
                                    </button>
                                )
                                : (
                                    <Link
                                        to={returnUrl}
                                        className="btn btn--medium btn--primary"
                                    >
                                        <span>{returlLinkTitle}</span>
                                    </Link>
                                )
                            }
                        </div>

                    </div>
                </div>
            </div>
        </Modal>
    );
}

InternalServerError.defaultProps = {
    returlLinkTitle: `Перейти к играм`,
    errorMessage: `500 Internal Server Error`,
}

InternalServerError.propTypes = {
    returnUrl: PropTypes.string,
    returlLinkTitle: PropTypes.string,
    onClickButton: PropTypes.func,
    errorMessage: PropTypes.string,
}

export default InternalServerError;
